/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms-contatti',
    templateUrl: './contatti.component.html',
    styleUrls: ['./contatti.component.scss']
})
export class PagesCmsContattiComponent { }
